import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import {
  createDefaultSearchOrderResultData,
  ISearchOrderResultData,
} from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersResult';

export interface IOrderSearchState {
  data: ISearchOrderResultData;
  fetchStatus: IFetchStatus;
  fetchError: string | null;
}

export const orderSearchInitialState: IOrderSearchState = {
  data: createDefaultSearchOrderResultData(),
  fetchStatus: createDefaultFetch(),
  fetchError: null,
};
